<div matDialogTitle>{{ title }}</div>
<mat-dialog-content>
    @if(savingMessage) {
        <div>
            <p-message icon="pi pi-info-circle" severity="info">Saving...</p-message>
        </div>
    }
    <form novalidate (keyup.enter)="ownerForm.valid && save()" class="form-container create-form" [formGroup]="ownerForm">
        @if(assets.length) {
            <div style="width: 100%; text-align: center;">
                @for (field of fields; track field?.id ?? field.field?.canonical_name ?? $index) {
                    @switch (field.field.canonical_name) {
                        @case (field.field.canonical_name) {
                        <div [class]="'bulk-move-modal-' + field.field.canonical_name">
                            <ah-owner-fields [field]="field" [assetForm]="ownerForm" [ownerOptions]="ownerOptions" [disableOwnerChange]="disableOwnerChange" (selectOwner)="selectOwner($event)" [divisionOptions]="divisionOptions" (selectDivision)="selectDivision($event)" [selectedOwner]="selectedOwner"
                            [currentFranchiseOption]="currentFranchiseOption" [ownedFranchiseOptions]="franchiseOptions" (selectFranchise)="selectFranchise($event)" [projectOptions$]="projectOptions$" (selectProject)="selectProject($event)" [warehouseOptions]="warehouseOptions"
                            (selectWarehouse)="selectWarehouse($event)" [locationOptions$]="locationOptions$" (selectLocation)="selectLocation($event)" [warehouseLocationOptions$]="warehouseLocationOptions$" (selectWarehouseLocation)="selectWarehouseLocation($event)"
                            [subLocationOptions$]="subLocationOptions$" (selectSubLocation)="selectSubLocation($event)" [warehouseSubLocationOptions$]="warehouseSubLocationOptions$" (selectWarehouseSubLocation)="selectWarehouseSubLocation($event)" [storageBoxOptions$]="storageBoxOptions$"
                            (selectStorageBox)="selectStorageBox($event)" [warehouseLocationSubLocationShelfDisabled]="warehouseLocationSubLocationShelfDisabled" [disabled]="saveDisabled"></ah-owner-fields>
                        </div>
                        }
                        @default { /* optional: handle unexpected canonical_name */ }
                    }
                }
            </div>
        }
    </form>
    @if(assets.length) {
        <div class="feedback-text flex-column">
            <p class="no-permission" *ngIf="assetsWithoutPermsTo.length">You do not have permission to {{ verb }} {{assetsWithoutPermsTo.length}} of the selected Assets.</p>
            <p class="permission">{{assets.length}} selected {{pluralize('Asset', assets.length)}} will be {{ verb }}d.</p>
        </div>
    }
    @if(!assets.length) {
        <div class="feedback-text flex-column">
            <p class="permission">You do not have permission to {{ verb }} any of the selected Assets.</p>
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions class="justify-content-center gap-20">
    <button mat-raised-button mat-dialog-close [disabled]="saveDisabled">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="ownerForm?.invalid || saveDisabled">Save</button>
</mat-dialog-actions>